import React from 'react'
import { motion } from 'framer-motion';
import { FaHeart, FaRecycle, FaShare } from 'react-icons/fa';
import { BsRecycle } from 'react-icons/bs';
import { ReplayCircleFilled } from '@mui/icons-material';
import { RiCheckLine, RiCloseLine, RiRecycleFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../contexts/ModalContext';
import useMunicipality from '../hooks/useMunicipality';
import useAuth from '../hooks/useAuth';
import { TextField } from '@mui/material';
import { addCitizenReferal, addCitizenSaving } from '../api';

const ActionBoxRowRound = ({ supportsSaving = false, supportsDonation = false }) => {
    const navigate = useNavigate();
    const { setModal, unSetModal, setWidth } = useModal()

    const { municipality } = useMunicipality();

    const { login, user, isAuthenticated, updateUserValues } = useAuth();

    return (
        <div className="container ">

            <div className='flex items-center '>
                <img
                    src={'../assets/images/more-actions.svg'}
                    alt={''}
                    className={`object-contain p-2  h-12 animate-waving-hand`}
                />
                <h3 className="text-3xl font-bold text-gray-700 ">Άλλες ενέργειες</h3></div>
            <h3 className="text-lg font-normal text-gray-700 pb-7">Δήλωσε τις ενέργειές σου και κέρδισε πόντους.</h3>


            <div className='grid !mx-auto  mb-12 mt-6 gap-y-10 md:gap-x-6 grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3  xl:gap-x-10 '>




                {!supportsDonation ? null : <motion.div initial={{ rotate: 25, scale: 0, opacity: 0 }}
                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                    transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 20
                    }}


                    className='rounded-3xl  p-[5px] bg-gradient-to-r from-green-400 via-blue-500 to-green-500  shadow-lg'>
                    <div className="relative justify-between flex flex-col  cursor-pointer rounded-3xl  p-5  bg-white">


                        <div className=" absolute -top-6 flex items-center justify-center bg-opacity-100 rounded-full shadow-md opacity-100 w-14 h-14 -right-3 bg-gradient-to-b from-green-400 via-blue-500 to-green-500">
                            <div className=" flex items-center justify-center font-bold text-gray-800 bg-white border-2 border-white rounded-full shadow-inner w-11 h-11 shadow-gray-200 text-md border-bg-gradient-to-r from-cyan-500 to-blue-500 hover:animate-ping">
                                {150}
                            </div>
                        </div>

                        <div className="flex items-center text-center justify-evenly w-full space-x-5">



                            <img

                                src={'../assets/images/recycle-donate.svg'}
                                alt={''}
                                className={`object-contain p-2  h-20`}
                            />

                            <p className=" font-semibold text-md text-gray-900 text-left w-52">Δώρισα στον Δήμο μου</p>
                            <div className="flex justify-center items-center space-x-2 w-150 md:w-[180px]  my-5  text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-green-400  to-green-500  transition ease-in-out  rounded-xl hover:shadow-lg  hover:shadow-orange-300  hover:-translate-y-1 hover:scale-110 duration-150"
                                onClick={() => {
                                    if (!isAuthenticated) {
                                        setModal(
                                            <div className='flex flex-col items-center justify-center py-5'>
                                                <motion.div
                                                    initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                    exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                    transition={{
                                                        damping: 20,
                                                        duration: 0.35
                                                    }}
                                                    className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                                    <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                </motion.div>
                                                <div className='font-bold text-lg text-center pt-5'>Κάνε εγγραφή ή συνδέσου για να κερδίσεις πόντους</div>
                                                <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                    onClick={() => { unSetModal() }}
                                                >OK</div>
                                            </div>
                                        )
                                    }
                                    else {
                                        let email = '';
                                        let phone = '';
                                        let description = '';
                                        setWidth(850)
                                        setModal(
                                            <div className='flex flex-col items-center justify-center py-5 w-full'>
                                                {/* <motion.div
                                                    initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                    exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                    transition={{
                                                        damping: 20,
                                                        duration: 0.35
                                                    }}
                                                    className='border-4 border-app_green_light rounded-full w-20 h-20 flex justify-center items-center'>

                                                    <div><RiCheckLine className='w-16 h-16 text-app_green_light'></RiCheckLine></div>
                                                </motion.div> */}
                                                <div className='font-bold  text-center pt-5'>Συμπλήρωσε τη φόρμα με τα αντικείμενα που επιθυμείς να προσφέρεις και ο Δήμος θα επικοινωνήσει μαζί σου για τις λεπτομέρειες. Κάθε φορά που παραδίδεις ένα αντικείμενο, λαμβάνεις ως επιβράβευση κουπόνι με 150 πόντους.</div>
                                                <div className='mb-2 mt-7'>Email:</div>
                                                <TextField
                                                    className='w-full !px-5'
                                                    // label="Email"
                                                    onChange={(event) => {
                                                        event.persist()
                                                        email = event.target.value;
                                                    }}
                                                    type="email"

                                                />
                                                <div className='mb-2 mt-7'>Τηλέφωνο:</div>
                                                <TextField
                                                    className='w-full !px-5'
                                                    // label="Email"
                                                    onChange={(event) => {
                                                        event.persist()
                                                        phone = event.target.value;
                                                    }}
                                                    type="number"


                                                />
                                                <div className='mb-2 mt-7'>Περισσότερες πληροφορίες:</div>
                                                <TextField
                                                    className='w-full !px-5'
                                                    // label="Email"
                                                    multiline
                                                    minRows={3}
                                                    onChange={(event) => {
                                                        event.persist()
                                                        description = event.target.value;
                                                    }}
                                                    type="text"


                                                />
                                                <div className="flex flex-col md:flex-row">
                                                    <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                        onClick={() => { unSetModal() }}
                                                    >Αποστολή</div>
                                                    <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_red to-app_brown  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                        onClick={() => { unSetModal() }}
                                                    >Ακύρωση</div>
                                                </div>
                                            </div>
                                        )
                                    }
                                }}
                            >

                                <div>Δώρισε</div>

                            </div>



                        </div>
                    </div>
                </motion.div>}



                {!supportsSaving ? null : <motion.div initial={{ rotate: 25, scale: 0, opacity: 0 }}
                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                    transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 20
                    }}


                    className='rounded-3xl  p-[5px] bg-gradient-to-r from-green-400 via-blue-500 to-green-500  shadow-lg '>
                    <div className="relative justify-between flex flex-col  cursor-pointer rounded-3xl  p-5  bg-white">


                        <div className=" absolute -top-6 flex items-center justify-center bg-opacity-100 rounded-full shadow-md opacity-100 w-14 h-14 -right-3 bg-gradient-to-b from-green-400 via-blue-500 to-green-500">
                            <div className=" flex items-center justify-center font-bold text-gray-800 bg-white border-2 border-white rounded-full shadow-inner w-11 h-11 shadow-gray-200 text-md border-bg-gradient-to-r from-cyan-500 to-blue-500 hover:animate-ping">
                                {25}
                            </div>
                        </div>

                        <div className="flex items-center text-center justify-evenly w-full space-x-5">



                            <img

                                src={'../assets/images/recycle-bicycle.svg'}
                                alt={''}
                                className={`object-contain p-2  h-20`}
                            />

                            <p className="font-semibold text-md text-gray-900 text-left w-52">Χρησιμοποίησα τα ΜΜΜ ή ποδήλατο</p>
                            <div className="flex justify-center items-center space-x-2 w-150 md:w-[180px]  my-5  text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-green-400  to-green-500  transition ease-in-out  rounded-xl hover:shadow-lg  hover:shadow-orange-300  hover:-translate-y-1 hover:scale-110 duration-150"
                                onClick={async () => {
                                    if (!isAuthenticated) {
                                        setModal(
                                            <div className='flex flex-col items-center justify-center py-5'>
                                                <motion.div
                                                    initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                    exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                    transition={{
                                                        damping: 20,
                                                        duration: 0.35
                                                    }}
                                                    className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                                    <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                </motion.div>
                                                <div className='font-bold text-lg text-center pt-5'>Κάνε εγγραφή ή συνδέσου για να κερδίσεις πόντους</div>
                                                <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                    onClick={() => { unSetModal() }}
                                                >OK</div>
                                            </div>
                                        )
                                    }
                                    else {

                                        const savingData =
                                        {
                                            CitizenId: user.citizenId,

                                        }
                                        const recycleResponse = await addCitizenSaving(savingData)
                                        if (recycleResponse.status === 2) {
                                            updateUserValues()
                                            setModal(
                                                <div className='flex flex-col items-center justify-center py-5'>
                                                    <motion.div
                                                        initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                        exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                        transition={{
                                                            damping: 20,
                                                            duration: 0.35
                                                        }}
                                                        className='border-4 border-app_green_light rounded-full w-20 h-20 flex justify-center items-center'>

                                                        <div><RiCheckLine className='w-16 h-16 text-app_green_light'></RiCheckLine></div>
                                                    </motion.div>
                                                    <div className='font-bold text-lg text-center pt-5'>Ευχαριστούμε για την καταχώρηση της πράσινης ενέργειας  στον Δήμο σου. Μόλις κέρδισες 25 πόντους.</div>
                                                    <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                        onClick={() => { unSetModal() }}
                                                    >OK</div>
                                                </div>
                                            )
                                        }
                                        else {
                                            setModal(
                                                <div className='flex flex-col items-center justify-center py-5'>
                                                    <motion.div
                                                        initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                        exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                        transition={{
                                                            damping: 20,
                                                            duration: 0.35
                                                        }}
                                                        className='border-4 border-app_green_light rounded-full w-20 h-20 flex justify-center items-center'>

                                                        <div><RiCheckLine className='w-16 h-16 text-app_green_light'></RiCheckLine></div>
                                                    </motion.div>
                                                    <div className='font-bold text-lg text-center pt-5'>Έχεις ήδη καταχωρήσει την εξοικονόμηση ενέργειας για αυτή την εβδομάδα. Μπορείς να καταχωρήσεις ξανά την εξοικονόμηση σου την ερχόμενη Δευτέρα.</div>
                                                    <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                        onClick={() => { unSetModal() }}
                                                    >OK</div>
                                                </div>
                                            )
                                        }
                                    }
                                }}
                            >

                                <div>Δήλωση</div>

                            </div>



                        </div>
                    </div>
                </motion.div>}


            </div>

            <div className='grid mt-6 gap-y-10 md:gap-x-32 grid-cols-1 lg:grid-cols-3 xl:gap-x-10 '>

                {!supportsSaving ? null : <motion.div initial={{ rotate: 25, scale: 0, opacity: 0 }}
                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                    transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 20
                    }} className=' flex flex-col justify-center items-center '

                    onClick={() => {
                        if (!isAuthenticated) {
                            setModal(
                                <div className='flex flex-col items-center justify-center py-5'>
                                    <motion.div
                                        initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                        exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                        transition={{
                                            damping: 20,
                                            duration: 0.35
                                        }}
                                        className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                        <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                    </motion.div>
                                    <div className='font-bold text-lg text-center pt-5'>Κάνε εγγραφή ή συνδέσου για να κερδίσεις πόντους</div>
                                    <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                        onClick={() => { unSetModal() }}
                                    >OK</div>
                                </div>
                            )
                        }
                        else {
                            // window.open('mailto:email@example.com?subject=Subject&body=Body%20goes%20here', 'blank')
                            window.location = 'mailto:isave@followgreen.gr?subject=Εξοικονόμηση%20Ενέργειας'
                            setModal(
                                <div className='flex flex-col items-center justify-center py-5'>
                                    <motion.div
                                        initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                        exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                        transition={{
                                            damping: 20,
                                            duration: 0.35
                                        }}
                                        className='border-4 border-app_green_light rounded-full w-20 h-20 flex justify-center items-center'>

                                        <div><RiCheckLine className='w-16 h-16 text-app_green_light'></RiCheckLine></div>
                                    </motion.div>
                                    <div className='font-bold text-lg text-center pt-5'>Στείλε μας το email για την καταχώρηση της πράσινης ενέργειας στον Δήμο σου. Θα σε ενημερώσουμε μόλις προστεθούν οι πόντοι στον λογαριασμό σου.</div>
                                    <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                        onClick={() => { unSetModal() }}
                                    >OK</div>
                                </div>
                            )
                        }
                    }}

                >
                    <div className="relative items-center w-52 h-52 hover:shadow-xl hover:drop-shadow-xl shadow-lg drop-shadow-lg justify-center flex flex-col  cursor-pointer rounded-full  bg-white">

                        <img
                            src={'../assets/images/recycle-energy.svg'}
                            alt={''}
                            className={`object-contain w-28 h-28`}
                        />
                        <div className=" absolute -top-0 flex items-center justify-center bg-opacity-100 rounded-full shadow-md opacity-100 w-14 h-14 -right-0 bg-gradient-to-b from-green-400 via-blue-500 to-green-500">
                            <div className=" flex items-center justify-center font-bold text-gray-800 bg-white border-2 border-white rounded-full shadow-inner w-11 h-11 shadow-gray-200 text-md border-bg-gradient-to-r from-cyan-500 to-blue-500 hover:animate-ping">
                                {500}
                            </div>
                        </div>


                    </div>
                    <div className="flex justify-center  p-1 px-3   mt-6 text-center  ">

                        <p className=" font-semibold text-gray-900 ">Αγορά ενεργειακού προϊόντος</p>
                    </div>
                </motion.div>
                }

                <motion.div initial={{ rotate: 25, scale: 0, opacity: 0 }}
                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                    transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 20
                    }} className=' flex flex-col justify-center items-center '
                    onClick={() => {

                        if (!isAuthenticated) {
                            setModal(
                                <div className='flex flex-col items-center justify-center py-5'>
                                    <motion.div
                                        initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                        exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                        transition={{
                                            damping: 20,
                                            duration: 0.35
                                        }}
                                        className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                        <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                    </motion.div>
                                    <div className='font-bold text-lg text-center pt-5'>Κάνε εγγραφή ή συνδέσου για να δωρίσεις πόντους.</div>
                                    <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                        onClick={() => { unSetModal() }}
                                    >OK</div>
                                </div>
                            )
                        }
                        else {
                            var email = '';
                            var validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            setModal(
                                <div className='flex flex-col items-center justify-center py-5'>

                                    <div className='font-bold text-lg text-center pt-5'>Προσκάλεσε έναν φίλο στο Followgreen και κέρδισε πόντους.</div>
                                    <div className='mb-2 mt-7'>Email:</div>
                                    <TextField
                                        className=''
                                        label="Email"

                                        onChange={(event) => {
                                            event.persist()
                                            if (event.target.value.match(validRegex)) {
                                                email = event.target.value;

                                                console.log(email)
                                            }
                                        }}
                                        type="email"


                                    // defaultValue={}
                                    // value={points}

                                    />
                                    <div className="flex flex-col md:flex-row">
                                        <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                            onClick={async () => {
                                                unSetModal()
                                                
                                                if (!email.match(validRegex)) {
                                                    setModal(
                                                        <div className='flex flex-col items-center justify-center py-5'>
                                                            <motion.div
                                                                initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                                exit={{ rotate: 1, scale: 1, opacity: 0 }}
    
                                                                animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                                transition={{
                                                                    damping: 20,
                                                                    duration: 0.35
                                                                }}
                                                                className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>
    
                                                                <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                            </motion.div>
                                                            <div className='font-bold text-lg text-center pt-5'>Λάθος Email</div>
                                                            <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                                onClick={() => { unSetModal() }}
                                                            >OK</div>
                                                        </div>
                                                    )
                                                }
                                                else {
                                                    const recycleData =
                                                    {
                                                        CitizenId: user.citizenId,
                                                        email: email,
                                                        name: user.name +" "+user.lastname
                                                    }
                                                    const recycleResponse = await addCitizenReferal(recycleData)
                                                    if (recycleResponse.status === 2) {
                                                        updateUserValues()
                                                        setModal(
                                                            <div className='flex flex-col items-center justify-center py-5'>
                                                                <motion.div
                                                                    initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                                    exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                                                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                                    transition={{
                                                                        damping: 20,
                                                                        duration: 0.35
                                                                    }}
                                                                    className='border-4 border-app_green_light rounded-full w-20 h-20 flex justify-center items-center'>

                                                                    <div><RiCheckLine className='w-16 h-16 text-app_green_light'></RiCheckLine></div>
                                                                </motion.div>
                                                                <div className='font-bold text-lg text-center pt-5'>Επιτυχής πρόσκληση στο Followgreen</div>
                                                                <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                                    onClick={() => { unSetModal() }}
                                                                >OK</div>
                                                            </div>
                                                        )
                                                    }
                                                    else {
                                                        setModal(
                                                            <div className='flex flex-col items-center justify-center py-5'>
                                                                <motion.div
                                                                    initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                                                    exit={{ rotate: 1, scale: 1, opacity: 0 }}
        
                                                                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                                                    transition={{
                                                                        damping: 20,
                                                                        duration: 0.35
                                                                    }}
                                                                    className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>
        
                                                                    <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                                                </motion.div>
                                                                <div className='font-bold text-lg text-center pt-5'>Το email χρησιμοποιείται ήδη</div>
                                                                <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                                                    onClick={() => { unSetModal() }}
                                                                >OK</div>
                                                            </div>
                                                        )
                                                    }
                                                }








                                                //await handleDontation(points, getProjectIdBySchoolId(school.SchoolId))
                                            }}
                                        >
                                            Καταχώρηση
                                        </div>
                                        <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_brown to-app_red  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                            onClick={() => { unSetModal() }}
                                        >
                                            Έξοδος
                                        </div>
                                    </div>
                                </div>
                            )
                            // await handleDontation(555120, getProjectIdBySchoolId(school.SchoolId))
                        }
                    }}

                >
                    <div className="relative items-center w-52 h-52 hover:shadow-xl hover:drop-shadow-xl shadow-lg drop-shadow-lg justify-center flex flex-col  cursor-pointer rounded-full  bg-white">

                        <img
                            src={'../assets/images/recycle-reffer.svg'}
                            alt={''}
                            className={`object-contain w-28 h-28`}
                        />
                        <div className=" absolute -top-0 flex items-center justify-center bg-opacity-100 rounded-full shadow-md opacity-100 w-14 h-14 -right-0 bg-gradient-to-b from-green-400 via-blue-500 to-green-500">
                            <div className=" flex items-center justify-center font-bold text-gray-800 bg-white border-2 border-white rounded-full shadow-inner w-11 h-11 shadow-gray-200 text-md border-bg-gradient-to-r from-cyan-500 to-blue-500 hover:animate-ping">
                                {25}
                            </div>
                        </div>


                    </div>
                    <div className="flex justify-center  p-1 px-3   mt-6 text-center  ">

                        <p className=" font-semibold text-gray-900 ">Σύσταση σε φίλο</p>
                    </div>
                </motion.div>


                <motion.div initial={{ rotate: 25, scale: 0, opacity: 0 }}
                    animate={{ rotate: 0, scale: 1, opacity: 1 }}
                    transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 20
                    }}
                    onClick={() => {
                        if (isAuthenticated)
                            navigate('../userpost');
                        else
                            setModal(
                                <div className='flex flex-col items-center justify-center py-5'>
                                    <motion.div
                                        initial={{ rotate: 500, scale: 0, opacity: 0 }}
                                        exit={{ rotate: 1, scale: 1, opacity: 0 }}

                                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                        transition={{
                                            damping: 20,
                                            duration: 0.35
                                        }}
                                        className='border-4 border-app_red rounded-full w-20 h-20 flex justify-center items-center'>

                                        <div><RiCloseLine className='w-16 h-16 text-app_red'></RiCloseLine></div>
                                    </motion.div>
                                    <div className='font-bold text-lg text-center pt-5'>Κάνε εγγραφή ή συνδέσου για να κερδίσεις πόντους</div>
                                    <div className='flex justify-center cursor-pointer py-3 md:mx-2 mt-6 text-center text-white font-semibold hover:text-white bg-gradient-to-r p-[6px] from-app_green to-app_green_light  transition ease-in-out  rounded-xl md:w-[150px] hover:shadow-lg    hover:-translate-y-1 hover:scale-110 duration-150'
                                        onClick={() => { unSetModal() }}
                                    >OK</div>
                                </div>
                            )
                    }}

                    className=' flex flex-col justify-center items-center '>
                    <div className="relative items-center w-52 h-52 hover:shadow-xl hover:drop-shadow-xl shadow-lg drop-shadow-lg justify-center flex flex-col  cursor-pointer rounded-full  bg-white">

                        <img
                            src={'../assets/images/recycle-mail.svg'}
                            alt={''}
                            className={`object-contain w-28 h-28`}
                        />
                        <div className=" absolute -top-0 flex items-center justify-center bg-opacity-100 rounded-full shadow-md opacity-100 w-14 h-14 -right-0 bg-gradient-to-b from-green-400 via-blue-500 to-green-500">
                            <div className=" flex items-center justify-center font-bold text-gray-800 bg-white border-2 border-white rounded-full shadow-inner w-11 h-11 shadow-gray-200 text-md border-bg-gradient-to-r from-cyan-500 to-blue-500 hover:animate-ping">
                                {25}
                            </div>
                        </div>


                    </div>
                    <div className="flex justify-center  p-1 px-3   mt-6 text-center  ">

                        <p className=" font-semibold text-gray-900 ">Πρόταση για δημοσίευση</p>
                    </div>
                </motion.div>
            </div>
        </  div>
    )
}

export default ActionBoxRowRound